const EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/i;
const EMAIL_GLOBAL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi;

const toDisplayWord = (word = "") => {
  if (!word) return "";
  if (word === word.toUpperCase() && word.length <= 3) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

const toDisplayName = (name = "") =>
  String(name)
    .split(/\s+/)
    .filter(Boolean)
    .map(toDisplayWord)
    .join(" ")
    .trim();

export const extractEmail = (value = "") => {
  const match = String(value || "").match(EMAIL_REGEX);
  return match?.[1]?.toLowerCase() || null;
};

export const normalizeAssigneeName = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "";

  const withoutBracketedEmail = raw
    .replace(/\(([^)]*@[^)]*)\)/g, " ")
    .replace(/<[^>]*@[^>]*>/g, " ");

  const withoutEmails = withoutBracketedEmail
    .replace(EMAIL_GLOBAL_REGEX, " ")
    .replace(/\s+/g, " ")
    .trim();

  return toDisplayName(withoutEmails);
};

export const formatNameWithEmail = (name = "", email = "") => {
  const cleanName = String(name || "").trim();
  const cleanEmail = String(email || "").trim();

  if (cleanName && cleanEmail) return `${cleanName} (${cleanEmail})`;
  if (cleanName) return cleanName;
  if (cleanEmail) return cleanEmail;
  return "Unknown";
};

export const getUserDisplayName = (user = {}) => {
  const firstLast = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
  return (
    firstLast ||
    String(user?.fullName || "").trim() ||
    String(user?.username || "").trim() ||
    ""
  );
};

export const getTaskAssigneeInfo = (task = {}) => {
  const nestedAssignee = task.assignee || null;
  const explicitFullName = String(nestedAssignee?.fullName || "").trim();
  const firstLastName = `${nestedAssignee?.firstName || ""} ${nestedAssignee?.lastName || ""}`.trim();
  const assigneeId =
    nestedAssignee?.id || task.assigneeId || task.assignee_id || null;
  const rawName =
    explicitFullName ||
    firstLastName ||
    "";
  const directEmail =
    nestedAssignee?.email || task.assigneeEmail || task.assignee_email || null;
  const extractedEmail = extractEmail(rawName);
  const assigneeEmail = (directEmail || extractedEmail || "").toLowerCase() || null;
  const normalizedName = normalizeAssigneeName(rawName);
  const hasOnlyEmailAsName = Boolean(extractedEmail) && !normalizedName;
  const displayName = hasOnlyEmailAsName ? "" : normalizedName || rawName;

  const key = assigneeEmail
    ? `email:${assigneeEmail}`
    : displayName
      ? `name:${displayName.toLowerCase()}`
      : assigneeId
        ? `id:${assigneeId}`
        : null;

  const label = displayName || "Unknown";

  return {
    assigneeId,
    assigneeEmail,
    normalizedName,
    key,
    label,
  };
};

export const getTaskAssigneeName = (task = {}, fallback = "Unknown") => {
  const label = getTaskAssigneeInfo(task).label;
  return label || fallback;
};
